// extracted by mini-css-extract-plugin
module.exports = {"main":"DCZIRz","mainOneColumn":"wESgAH","cart":"TjR9LY","summary":"mPEOfl","footer":"wSh6Nl"};